<template>
  <div
    class="bg-white max-w-md border-vectric border-4 rounded-t-2xl rounded-br-2xl mt-6 p-6 mx-auto shadow-lg"
  >
    <div class="text-center">
      <p
        class="mt-3 max-w-md mx-auto text-base  sm:text-xl md:mt-5 md:text-xl md:max-w-3xl"
      >
        {{ message }}
      </p>

      <router-link to="/login">
        <a class="raleway-btn bg-vectric text-darkBlue hover:bg-darkBlue  hover:text-white mt-2">
          Login
        </a>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoginInToJoinIn",
  props: {
    message: {
      type: String,
      required: false,
      default: "Log in to Join in"
    }
  }
};
</script>

<style scoped></style>
